import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Message } from "../../../@types/message";
import axiosInstance from "../../../utils/axiosConfig";
export const findMessages = createAsyncThunk(
  "location/findMessages",
  async (idLocation: string, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`${api.baseURL}message`, {
        params: {
          where: {
            locations: { contains: `${idLocation}]` },
          },
          sort: "createdAt DESC",
          limit: 80,
          populate: ["createdBy", "document"].join(","),
        },
      });
      return data as Message[];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
